import { render, staticRenderFns } from "./MenuAlto.vue?vue&type=template&id=0d76aa1a&scoped=true&"
import script from "./MenuAlto.vue?vue&type=script&lang=js&"
export * from "./MenuAlto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76aa1a",
  null
  
)

export default component.exports